module.exports = __webpack_public_path__ + "img/returnunit.4126f8b7.png";